function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Badge } from "reactstrap";
import styled from "styled-components";
import { STATUS_CONFIRMED, STATUS_FINISHED, STATUS_PENDING, STATUS_REJECTED, STATUS_WITHDRAWN } from "../../../constants/component";
const StyledBadge = styled(Badge)`
  font-size: 1rem !important;
  padding-left: .8rem;
  padding-right: .8rem
`;

class StatusBadge extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "statusConfig", () => {
      switch (this.props.status) {
        case STATUS_PENDING:
          return {
            color: 'info',
            status: 'Pending'
          };

        case STATUS_WITHDRAWN:
          return {
            color: 'warning',
            status: 'Withdrawn'
          };

        case STATUS_CONFIRMED:
          return {
            color: 'primary',
            status: 'Confirmed'
          };

        case STATUS_REJECTED:
          return {
            color: 'danger',
            status: 'Rejected'
          };

        case STATUS_FINISHED:
          return {
            color: 'success',
            status: 'Finished'
          };

        default:
          return {
            color: 'light',
            status: 'Unknown'
          };
      }
    });

    _defineProperty(this, "renderStatus", () => {
      const {
        color,
        status
      } = this.statusConfig();
      return /*#__PURE__*/React.createElement(StyledBadge, {
        color: `${color}-lighten`,
        cypress: 'statusBadge'
      }, status);
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderStatus());
    });
  }

}

export default StatusBadge;